import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border border-2 border-gray-300 border-hover" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_3 = { class: "fs-4 fw-boldest text-dark p-2 border-primary border-bottom w-100" }
const _hoisted_4 = { class: "row m-2" }
const _hoisted_5 = { class: "row m-2" }
const _hoisted_6 = { class: "col-md-10 .offset-md-3 text-gray-600 fw-bold fs-6" }
const _hoisted_7 = { class: "text-gray-600 fw-bolder fs-6" }
const _hoisted_8 = { class: "text-gray-600 fw-bold fs-6 mt-1" }
const _hoisted_9 = { class: "text-gray-600 fw-bold fs-6" }
const _hoisted_10 = { class: "text-gray-600 fw-bold fs-6 mb-3" }
const _hoisted_11 = { class: "col-md-10 .offset-md-3 text-gray-600 fw-bold fs-6" }
const _hoisted_12 = { class: "text-gray-600 fw-bold fs-6" }
const _hoisted_13 = { class: "text-gray-600 fw-bold fs-6 mb-3" }
const _hoisted_14 = { class: "col-md-1 .offset-md-3 card-toolbar" }
const _hoisted_15 = { class: "card p-4" }
const _hoisted_16 = { class: "d-flex flex-wrap mb-5" }
const _hoisted_17 = { class: "border border-gray-900 border-dashed rounded min-w-80px py-3 px-4 me-4 mb-3" }
const _hoisted_18 = { class: "fs-6 text-gray-600 fw-bolder" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-600" }, "Sales", -1)
const _hoisted_20 = { class: "border border-gray-900 border-dashed rounded min-w-80px py-3 px-4 me-4 mb-3" }
const _hoisted_21 = { class: "fs-6 text-gray-600 fw-bolder" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-600" }, "Chargebacks", -1)
const _hoisted_23 = { class: "border border-gray-900 border-dashed rounded min-w-80px py-3 px-4 mb-3" }
const _hoisted_24 = { class: "fs-6 text-gray-600 fw-bolder" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-600" }, "Ratio", -1)
const _hoisted_26 = ["title"]
const _hoisted_27 = ["aria-valuenow"]
const _hoisted_28 = { class: "symbol symbol-hover h-40px" }
const _hoisted_29 = ["title"]
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.href ? _ctx.href : '#',
      class: "row card-header border-0 pt-0"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.dba_alias), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, "ID: " + _toDisplayString(_ctx.id), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, "DBA: " + _toDisplayString(_ctx.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, " MID: " + _toDisplayString(_ctx.getDescription), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.getStatusDataBadgeColor, "btn btn-sm badge fw-bolder me-auto px-4 py-3"]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClickStatus()), ["prevent"]))
          }, _toDisplayString(_ctx.getStatus), 3)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.totalSales), 1),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.totalChargebacks), 1),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.cbratio) + "%", 1),
          _hoisted_25
        ])
      ]),
      _createElementVNode("div", {
        class: "h-4px w-100 bg-light mb-5",
        "data-bs-toggle": "tooltip",
        title: `This merchant ${_ctx.progress}% completed`
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.getStatusDataColor, "rounded h-4px"]),
          role: "progressbar",
          style: _normalizeStyle({ width: _ctx.progress + `%` }),
          "aria-valuenow": _ctx.progress,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, null, 14, _hoisted_27)
      ], 8, _hoisted_26),
      _createElementVNode("div", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apis, (api, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "symbol symbol-30px symbol-square pe-2",
            "data-bs-toggle": "tooltip",
            title: api.connection.conn_name
          }, [
            _createElementVNode("img", {
              alt: "Pic",
              src: api.connection.logo_url
            }, null, 8, _hoisted_30)
          ], 8, _hoisted_29))
        }), 128))
      ])
    ])
  ]))
}